import React from 'react'

/**
 * Utility functions for rendering badges
 * Used across multiple pages for consistent styling
 */

/**
 * Get status badge configuration for events
 */
export function getEventStatusBadge(status: string) {
  const statusConfig = {
    active: { label: 'Actif', className: 'bg-green-900/50 text-green-300 border-green-700/50' },
    completed: { label: 'Terminé', className: 'bg-blue-900/50 text-blue-300 border-blue-700/50' },
    draft: { label: 'Brouillon', className: 'bg-slate-700/50 text-slate-300 border-slate-600/50' },
    cancelled: { label: 'Annulé', className: 'bg-red-900/50 text-red-300 border-red-700/50' },
    hidden: { label: 'Masqué', className: 'bg-yellow-900/50 text-yellow-300 border-yellow-700/50' },
  }
  return statusConfig[status as keyof typeof statusConfig] || statusConfig.draft
}

/**
 * Get plan type badge configuration
 */
export function getPlanTypeBadge(planType: string) {
  const planConfig = {
    free: { label: 'Gratuit', className: 'text-slate-400' },
    one_shot: { label: '🎯 Événement unique', className: 'text-purple-400' },
    subscription: { label: '⭐ Abonnement', className: 'text-cyan-400' },
  }
  return planConfig[planType as keyof typeof planConfig] || planConfig.free
}

/**
 * Render status badge component
 */
export function StatusBadge({ status }: { status: string }) {
  const config = getEventStatusBadge(status)
  return (
    <span className={`px-3 py-1 rounded-full text-xs font-bold border ${config.className}`}>
      {config.label}
    </span>
  )
}

/**
 * Render plan type badge component
 */
export function PlanTypeBadge({ planType, variant = 'text' }: { planType: string; variant?: 'text' | 'badge' }) {
  const config = getPlanTypeBadge(planType)
  
  if (variant === 'badge') {
    return (
      <span className={`px-3 py-1 rounded-full text-xs font-bold border border-slate-700/50 ${config.className}`}>
        {config.label}
      </span>
    )
  }
  
  return <span className={`text-xs font-mono ${config.className}`}>{config.label}</span>
}
